angular.module('iqxCore')
  .controller('LoginCtrl', function ($scope, $location, $http, ApplicationSvc, ApiSvc, $routeParams, loginSvc, serviceWorkerSvc, $cookies, BehaviourSvc) {
    $scope.loginExists = false
    $scope.disableLogin = false
    loginSvc.setLoggedOut() // set them to logged out as they are on the login page

    // iOS App Login
    if ($routeParams && $routeParams.token && $routeParams.pushToken) {
      var loginToken = $routeParams.token
      var pushToken = $routeParams.pushToken
      $scope.disableLogin = true

      $scope.isLoading = true
      $http.post('/api/auth/token', { token: loginToken })
        .then(function (res) {

          ApiSvc.CheckIQXResult(res.data)

          loginSvc.setLoggedIn(res.data)
            .then(function () {
              // store token!!!!!!!!!!!
              return serviceWorkerSvc.registerIOSPush(pushToken)
            })
            .then(function () {
              $cookies.putObject('isApp', true, ApplicationSvc.cookieOptions)
              if ($scope.isSwitchedOn('PINAUTHALLOW') === true && $scope.isSwitchedOn('PINAUTHFORCE') === true && ApplicationSvc.currentUser.pinauth !== true) {
                $location.url('/settings?createPIN=true&continue=/home')
              } else {
                var p = ApplicationSvc.postLoginRoute  // Navigate to wherever was last requested in the un-loggedin state (default=/)
                ApplicationSvc.postLoginRoute = '/'   // Reset the default

                // DO SOMETHING WITH PUSH TOKEN!!
                $location.path(p + '?pushToken=' + pushToken)
              }
            })
            .then(function () {
              if (ApplicationSvc.currentUser.UserClass === "CLIENT") {
                return loginSvc.getClientDivision()
              }
            })
        })
        .catch(function (e) {
          console.error(e)
        })
    }

    if ($routeParams && $routeParams.exists && $routeParams.exists == 'true') {
      $scope.loginExists = true
    }

    if ($routeParams && $routeParams.registerRefused && $routeParams.registerRefused == 'true') {
      $scope.loginerr = 'As you have refused our terms and conditions, we cannot take your registration further.'
    }

    if ($routeParams && $routeParams.registerLater && $routeParams.registerLater == 'true') {
      $scope.loginerr = 'Please log in using the username and password you created.'
    }

    if ($routeParams && $routeParams.inactivity && $routeParams.inactivity == 'true') {
      $scope.loginerr = 'You have been logged out due to inactivity.  Please login again.'
    }

    if ($routeParams && $routeParams.PINRemoved) {
      $scope.loginerr = 'Your device is no longer using a PIN, please login again.'
    }

    $scope.login = function (username, password) {
      $scope.isLoading = true
      $scope.loginerr = ''
      if (!username) {
        $scope.isLoading = false
        return ($scope.loginerr = 'Missing user name')
      }
      if (!password) {
        $scope.isLoading = false
        return ($scope.loginerr = 'Missing password')
      }

      return $http.post('/api/auth/login', { username: username, password: password })
        .then(function (res) {
          ApiSvc.CheckIQXResult(res.data)

          loginSvc.setLoggedIn(res.data)
            .then(function () {
              if ($scope.isSwitchedOn('PINAUTHALLOW') === true && $scope.isSwitchedOn('PINAUTHFORCE') === true && ApplicationSvc.currentUser.pinauth !== true) {
                $location.url('/settings?createPIN=true&continue=/home')
              } else {
                var userAgent = window.navigator.userAgent.toLowerCase()
                var safari = /zzzsafari/.test(userAgent)
                var ios = /iphone|ipod|ipad/.test(userAgent)

                if (ios && !safari) {
                  serviceWorkerSvc.registerPush()
                }
                var p = ApplicationSvc.postLoginRoute  // Navigate to wherever was last requested in the un-loggedin state (default=/)
                ApplicationSvc.postLoginRoute = '/'   // Reset the default

                $location.url(p)
              }
            })
            .then(function () {
              if (ApplicationSvc.currentUser.UserClass === "CLIENT") {
                return loginSvc.getClientDivision()
              }
            })
            .then(function () {
              if (ApplicationSvc.currentUser.UserClass !== "CANDIDATE") {
                return BehaviourSvc.get()
                  .then(function () {
                    var behaviourCookie = $cookies.getObject('IQXBehaviour')
                    ApplicationSvc.params.behaviour = angular.fromJson(behaviourCookie)
                  })
              }
            })
        })
        .catch(function (err) {
          if (angular.isObject(err) && err.status && err.status == 401) {
            $scope.loginerr = 'Invalid user name or password'
          } else {
            $scope.loginerr = ApiSvc.ExtractError(err)
          }
          $scope.isLoading = false
          $scope.disableLogin = false
        })
    }

    $scope.register = function () {
      $location.url("/xregister")
    }

    $scope.resetPassword = function () {
      $location.url("/resetpassword")
    }

    // Auto Login via link
    if ($routeParams && $routeParams.autologin) {
      let loginPart = decodeURIComponent($routeParams.autologin)
      $scope.disableLogin = true
      $scope.isLoading = true
      loginPart = atob(loginPart)
      loginPart = loginPart.split(':') // [0] username | [1] password

      return $scope.login(loginPart[0], loginPart[1])
    }
  })